var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classes},[_vm._v("\n    "+_vm._s(_vm.data.label)+"\n    "),(_vm.showArrow)?_c('i',{staticClass:"ivu-icon ivu-icon-ios-arrow-right"}):_vm._e(),_vm._v(" "),(_vm.showLoading)?_c('i',{staticClass:"ivu-icon ivu-icon-load-c ivu-load-loop"}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57cc9d4a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview/src/components/cascader/casitem.vue
// module id = null
// module chunks = 